let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4fcc8")).then(() => parcelRequire('ksEoD'));